<template>
  <div :class="prefix">
    <div :class="prefix+'__header'">
      <span v-if="hasSelfListBody" class="mr-auto">{{ count + formatedItems }}</span>
      <t-checkbox
        v-else
        ref="checkAll"
        :disabled="checkedAllDisabled"
        :indeterminate="isIndeterminate"
        :size="size"
        :checked="allChecked"
        class="form-transfer-list__header-title"
        @change="$_onCheckboxAllChange"
      >{{ count + formatedItems }}</t-checkbox>
      <span :class="prefix+'__header-targer'">{{ title }}</span>
    </div>
    <div v-if="filterable" :class="prefix+'__searcher'">
      <t-input v-model.trim="query" :placeholder="filterPlaceholder" icon-placement="right" icon="search-outline" :size="size"></t-input>
    </div>
    <template v-if="filteredData.length > 0">
      <div v-if="hasSelfListBody" :class="prefix+'__body'" class="px-12">
        <slot name="listBody" :data="filteredData"></slot>
      </div>
      <ul v-else :class="[prefix+'__body', 'list-unstyled']">
        <li v-for="entry in filteredDatas" :key="entry.key">
          <t-checkbox
            :disabled="entry.disabled"
            :checked="entry.isChecked"
            :size="size"
            class="transfer-list__text"
            @change="$_onCheckboxChange(entry)"
          >
            <t-transfer-list-item :data="entry" :disabled="entry.disabled"></t-transfer-list-item>
          </t-checkbox>
        </li>
      </ul>
    </template>
    <div v-else :class="prefix+'__not-found'">
      <t-empty size="sm" :desc="notFoundText"></t-empty>
    </div>
    <div v-if="showFooter" ref="list-footer" :class="prefix+'__footer'">
      <slot name="list-footer"></slot>
    </div>
  </div>
</template>

<script>
import { TCheckbox } from '../checkbox'
import TInput from '../input'
import TTransferListItem from './list-item.js'
import Locale from '../../mixins/locale'
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'TTransferList',
  components: {
    TCheckbox,
    TInput,
    TTransferListItem
  },
  mixins: [Locale],
  props: {
    data: {
      type: Array,
      default() {
        /* istanbul ignore next */
        return []
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    title: {
      type: [String, Number],
      default: ''
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    filterMethod: {
      type: Function,
      default: null
    },
    notFoundText: {
      type: String,
      default: '暂无数据'
    },
    direction: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'sm'].includes(value)
      }
    },
    checkedKey: {
      type: Array,
      default() {
        /* istanbul ignore next */
        return []
      }
    },
    renderContent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      prefix: PREFIX_CLASS + 'transfer-list',
      query: '',
      checkedKeys: this.checkedKey,
      filteredData: []
    }
  },
  computed: {
    hasSelfListBody() {
      return typeof this.$parent.$scopedSlots.listBodyLeft === 'function' || typeof this.$parent.$scopedSlots.listBodyRight === 'function'
    },
    count() {
      const keysCount = this.checkedKeys.length
      return `${keysCount > 0 ? keysCount + '/' : ''}${this.data.length}`
    },
    allChecked() {
      const keysCount = this.checkedKeys.length
      return (
        this.data.filter(data => !data.disabled).length === keysCount &&
        keysCount !== 0
      )
    },
    checkedAllDisabled: function() {
      return this.data.filter(data => !data.disabled).length === -1
    },
    isIndeterminate: function() {
      return (
        this.checkedKeys.length > 0 &&
        this.checkedKeys.length < this.data.length
      )
    },
    filteredDatas() {
      return this.filteredData.map(data => {
        return { ...data, isChecked: this.checkedKeys.includes(data.key) }
      })
    },
    formatedItems() {
      return this.t(`t.transfer.titles.items`)
    }
  },
  watch: {
    data() {
      this.$_updateFilteredData()
    },
    checkedKeys(newVal) {
      if (this.$parent && this.$parent.$refs) {
        this.$parent.$refs.operation[this.direction + 'Active'] = !!newVal.length
      }
      if (newVal.toString() !== this.checkedKey.toString() && this.$parent) {
        this.$parent.handleCheckedChange(this.direction, newVal)
      }
    },
    checkedKey(newVal) {
      this.checkedKeys = newVal && newVal.length > 0 ? newVal : []
      // this.$_updateFilteredData()
    },
    query() {
      this.$_updateFilteredData()
    }
  },
  created() {
    this.$_updateFilteredData()
  },
  mounted() {
    const isCheckedKeysNotEmpty = this.checkedKeys.length > 0
    if (this.$parent && this.$parent.$refs) {
      this.$parent.$refs.operation[this.direction + 'Active'] = isCheckedKeysNotEmpty
    }
  },
  methods: {
    $_isChecked(data) {
      return this.checkedKeys.includes(data.key)
    },
    $_onCheckboxChange(data) {
      if (this.$_isChecked(data)) {
        this.checkedKeys = this.checkedKeys.filter(key => key !== data.key)
      } else {
        this.checkedKeys.push(data.key)
      }
    },
    checkAll(checked) {
      if (checked === undefined) {
        checked = !this.$refs.checkAll.checked
      }
      this.checkedKeys = checked ? this.data.map(v => v.key) : []
    },
    $_onCheckboxAllChange(checked) {
      /* istanbul ignore next */
      this.checkAll(checked)
    },
    $_updateFilteredData() {
      this.filteredData = this.$_getFilteredData()
    },
    $_filterData(val) {
      return this.filterMethod(val, this.query)
    },
    $_getFilteredData() {
      return this.data.filter(val => this.$_filterData(val))
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/module/transfer/list.vue